import React,{useEffect,useState} from "react";
import "./bottomBar.css";
import obj from "../../../package.json";
import facebook from "../../assets/iconFace.png";
import instagram from "../../assets/iconInsta.png";
import whatsapp from "../../assets/iconWhats.png";

const BottomBar = ({ dash }) => {
  const [dashboard,setDashboard] = useState(dash)
  // useEffect(()=>{
  //   setDashboard(dash)
  // },[dash])

  return (
    <div className={"footerRow "+' '+`${dashboard ? null : "footer-row-dashboard"}`}>
      <div className={'logoRow'}>
        <div className="Allestec">
          <span className="Alles">Alles</span>
          <span className="tec">tec </span>
        </div>
        <div className="rowImages">
          <a
            href="https://www.facebook.com/Allestec-Automa%C3%A7%C3%B5es-e-Sistemas-112120823674257/"
            target="_blank"
          >
            <img
              src={facebook}
              alt="facebook"
              width="20vw"
              height="auto"
            ></img>
          </a>
          <a
            href="https://www.instagram.com/allestec.solucoes/"
            target="_blank"
          >
            <img
              src={instagram}
              alt="instagram"
              width="20vw"
              height="auto"
            ></img>
          </a>
          <a href="https://wa.me/5547999838540" target="_blank">
            <img
              src={whatsapp}
              alt="whatsapp"
              width="20vw"
              height="auto"
            ></img>
          </a>
        </div>
      </div>
      <div className="rowVersion">V.{obj.version}</div>
    </div>
  );
}

export default BottomBar
